import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/agreement/help')
    },
    {
      path: '/server',
      name: 'server',
      component: () => import('@/views/agreement/server')
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('@/views/agreement/info')
    },
    {
      path: '/banquan',
      name: 'banquan',
      component: () => import('@/views/agreement/banquan')
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   var sUserAgent = navigator.userAgent
//   if (sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1 || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1) {
//     location.href = 'https://m.taowoapp.com'
//   } else {
//     next()
//   }
// })

export default router
